import React from "react";
import "./Sidebar.scss";
import { MultiNodesPanel } from "./panels/MultiNodesPanel";
import { SettingsPreview } from "./panels/SettingsPreview";
import { useTranslation } from "react-i18next";
import { Documentation } from "./panels/Documentation";
import { useGraph } from "../../../hooks/useGraph";
import { Button } from "primereact/button";
import { useDispatch } from "react-redux";
import { setSizePanel } from "../editorSlice";
import CrontabView from "./panels/Cron/CrontabView";
import { NodeConfiguration } from "./panels/NodeConfiguration";
import { LaunchedFlows } from './panels/LaunchedFlows';
import { LabelsSelectorsProvider } from '@kosmos/shared';
import { TopologyVersions } from './panels/versions/TopologyVersions';

interface Props {
  pane?: string;
  arg?: any;
}

export const Sidebar = ({ pane, arg }: Props) => {
  const { t } = useTranslation();
  const { engine } = useGraph();
  const dispatch = useDispatch();

  const handleKeyDown = (e: any) => {
    if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'c') {
      e.stopPropagation();
    }
  };
  let component = <div>{t("message.nothing-show")}</div>;
  switch (pane) {
    case "multiSelection":
      component = <MultiNodesPanel />;
      break;
    case "settings":
      component =
          <LabelsSelectorsProvider serviceUrl="/api/labels?vstoreobject=topologies">
            <SettingsPreview id={arg} />
          </LabelsSelectorsProvider>
      break;
    case "documentation":
      component = <Documentation />;
      break;
    case "cron":
      component = <CrontabView />;
      break;
    case "configuration":
      component = <NodeConfiguration />;
      break;
    case "flows":
      component = <LaunchedFlows topologyID={arg.topologyID} topologyVersion={arg.topologyVersion}/>;
      break;
    case "versions":
      component = <TopologyVersions topology={arg.topology} catalog={arg.catalog} />;
      break;
  }

  const lockSupprKey = () => {
    localStorage.setItem("supprKey", "true");
  };
  const freeSupprKey = () => {
    localStorage.setItem("supprKey", "false");
  };

  return (
    <div
      className={"editor-sidebar"}
      onFocus={lockSupprKey}
      onBlur={freeSupprKey}
      onKeyDown={handleKeyDown}
    >
      <div className="flex justify-content-end">
        <Button
          icon="pi pi-times"
          onClick={() => {
            dispatch(setSizePanel("100%"));
          }}
          text
          severity="secondary"
          aria-label="Bookmark"
        />
      </div>
      {component}
    </div>
  );
};
